import { Routes } from '@angular/router';
import { EventDetailComponent } from './components/event-detail/event-detail';
import { ThankYouComponent } from './components/thank-you/thank-you';
import { AttendeeListComponent } from './signin/attendee-list/attendee-list.component';

export const routes: Routes = [
  { path: '', redirectTo: 'register', pathMatch: 'full' },
  { path: 'register', component: EventDetailComponent },
  { path: 'thank-you', component: ThankYouComponent },
  { path: 'signin', component: AttendeeListComponent },
  { path: '**', redirectTo: 'register' }
];
